let page = 2;
let readyLoadMore = true;
let maxItem = false;

$(document).on("scroll", function () {
  let agentIDGroup = $("#agent-id-group");

  if (agentIDGroup.length > 0) {
    let hT = agentIDGroup.offset().top,
      hH = agentIDGroup.outerHeight(),
      wH = $(window).height(),
      wS = $(this).scrollTop();
    if (wS > hT + hH - wH && readyLoadMore && !maxItem) {
      readyLoadMore = false;
      let submitAjax = $.ajax({
        url: Routes.agents_path({ load_more: true, page: page }),
        method: "GET",
      });
      submitAjax.done(function (response) {
        if (response.max_data) {
          maxItem = true;
          return;
        }
        $("#agent-id-group").append(response);
        if ($(".select-all").is(":checked")) {
          $(".select-all").addClass("half-checked");
        }
        page++;
        readyLoadMore = true;
      });
      submitAjax.fail(function (response) {
        readyLoadMore = true;
      });
    }
  }
});
